import { InjectionToken } from "@angular/core";
import { DeviceInfo } from "ngx-device-detector";

export interface DeviceDetector {
  getUserAgent: () => string;
  getOperationalSystem: () => string;
  isDesktop: (userAgent?: string) => boolean;
  setDeviceInfo: (userAgent?: string) => void;
  getDeviceInfo: () => DeviceInfo
}

export const DEVICE_DETECTOR = new InjectionToken<DeviceDetector>('Device detector service');